import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const universityConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'University Area Tampa Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in University area, Tampa FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_university_tampa',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving University Area',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in the University Area Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide dependable tree care to 
     the residential neighborhoods and commercial properties surrounding the 
     <strong>University of South Florida</strong> area in Tampa. This high density 
     community has a mix of established homes, apartment complexes, and commercial 
     corridors all with trees that grow close to structures and require regular 
     professional attention to stay safe and compliant.`,

    `We specialize in <strong>hazardous tree removal and trimming in mixed use 
     urban settings</strong> large limbs over rental properties and commercial 
     buildings, storm damaged trees, palms crowding parking lots and utility lines, 
     and canopy management that keeps properties safe and tenants protected. 
     We work efficiently around busy schedules.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, affordable tree care 
     throughout the <strong>University area</strong> and surrounding 
     <strong>North Tampa</strong> communities keeping every property safe 
     and well maintained all year long.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'University, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_University = () => <LocationPage config={universityConfig} />;
export default Services_University;
